// Generated by Melange

import * as Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign from "./buhta_edo_sign_v1alpha1_document_sign.js";
import * as Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign from "./buhta_edo_sign_v1alpha1_public_sign.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_api__Google_api_httpbody from "../../third_party/google_api/gen/google_api_httpbody.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetPublicSignDocumentRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_sign_v1alpha1_public_sign_service.ml",
      1268,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetPublicSignDocumentResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_sign_v1alpha1_public_sign_service.ml",
      1328,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetPublicSignDocumentContentRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_sign_v1alpha1_public_sign_service.ml",
      1389,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetPublicSignDocumentPreviewRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_sign_v1alpha1_public_sign_service.ml",
      1453,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListPublicSignDocumentsRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_sign_v1alpha1_public_sign_service.ml",
      1516,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListPublicSignDocumentsResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_sign_v1alpha1_public_sign_service.ml",
      1576,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ProcessPublicSignDocumentsRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_sign_v1alpha1_public_sign_service.ml",
      1637,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ProcessPublicSignDocumentsResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_sign_v1alpha1_public_sign_service.ml",
      1700,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.edo.sign.v1alpha1.GetPublicSignDocumentRequest";
}

function make(hashOpt, param) {
  const hash = hashOpt !== undefined ? hashOpt : "";
  return {
          hash: hash
        };
}

const merge_hash = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "hash",
            "hash"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge(t1, t2) {
  return {
          hash: Curry._2(merge_hash, t1.hash, t2.hash)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "hash",
                    "hash"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._2(serialize, writer, param.hash);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(hash) {
  return {
          hash: hash
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.GetPublicSignDocumentRequest", spec(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.hash);
  };
}

function constructor$1(hash) {
  return {
          hash: hash
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.GetPublicSignDocumentRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetPublicSignDocumentRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.edo.sign.v1alpha1.GetPublicSignDocumentResponse";
}

function make$1(intent, param) {
  return {
          intent: intent
        };
}

const $$let = Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign.Buhta.Edo.Sign.V1alpha1.PublicSignIntent;

const merge_intent = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "intent",
            "intent"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          intent: Curry._2(merge_intent, t1.intent, t2.intent)
        };
}

function spec$1(param) {
  const $$let = Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign.Buhta.Edo.Sign.V1alpha1.PublicSignIntent;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "intent",
                    "intent"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.intent);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(intent) {
  return {
          intent: intent
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.GetPublicSignDocumentResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.intent);
  };
}

function constructor$3(intent) {
  return {
          intent: intent
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.GetPublicSignDocumentResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetPublicSignDocumentResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.edo.sign.v1alpha1.GetPublicSignDocumentContentRequest";
}

function make$2(hashOpt, attachmentOpt, param) {
  const hash = hashOpt !== undefined ? hashOpt : "";
  const attachment = attachmentOpt !== undefined ? attachmentOpt : false;
  return {
          hash: hash,
          attachment: attachment
        };
}

const merge_hash$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "hash",
            "hash"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_attachment = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "attachment",
            "attachment"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

function merge$2(t1, t2) {
  return {
          hash: Curry._2(merge_hash$1, t1.hash, t2.hash),
          attachment: Curry._2(merge_attachment, t1.attachment, t2.attachment)
        };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "hash",
                    "hash"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "attachment",
                        "attachment"
                      ],
                      Ocaml_protoc_plugin__Spec.bool,
                      false
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.hash, param.attachment);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(hash, attachment) {
  return {
          hash: hash,
          attachment: attachment
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.GetPublicSignDocumentContentRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.hash, param.attachment);
  };
}

function constructor$5(hash, attachment) {
  return {
          hash: hash,
          attachment: attachment
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.GetPublicSignDocumentContentRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetPublicSignDocumentContentRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.edo.sign.v1alpha1.GetPublicSignDocumentPreviewRequest";
}

function make$3(hashOpt, attachmentOpt, param) {
  const hash = hashOpt !== undefined ? hashOpt : "";
  const attachment = attachmentOpt !== undefined ? attachmentOpt : false;
  return {
          hash: hash,
          attachment: attachment
        };
}

const merge_hash$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "hash",
            "hash"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_attachment$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "attachment",
            "attachment"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

function merge$3(t1, t2) {
  return {
          hash: Curry._2(merge_hash$2, t1.hash, t2.hash),
          attachment: Curry._2(merge_attachment$1, t1.attachment, t2.attachment)
        };
}

function spec$3(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "hash",
                    "hash"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "attachment",
                        "attachment"
                      ],
                      Ocaml_protoc_plugin__Spec.bool,
                      false
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._3(serialize$3, writer, param.hash, param.attachment);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(hash, attachment) {
  return {
          hash: hash,
          attachment: attachment
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.GetPublicSignDocumentPreviewRequest", spec$3(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.hash, param.attachment);
  };
}

function constructor$7(hash, attachment) {
  return {
          hash: hash,
          attachment: attachment
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.GetPublicSignDocumentPreviewRequest", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetPublicSignDocumentPreviewRequest, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

function name$4(param) {
  return ".buhta.edo.sign.v1alpha1.ListPublicSignDocumentsRequest";
}

function make$4(hashOpt, param) {
  const hash = hashOpt !== undefined ? hashOpt : "";
  return {
          hash: hash
        };
}

const merge_hash$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "hash",
            "hash"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$4(t1, t2) {
  return {
          hash: Curry._2(merge_hash$3, t1.hash, t2.hash)
        };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "hash",
                    "hash"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._2(serialize$4, writer, param.hash);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(hash) {
  return {
          hash: hash
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.ListPublicSignDocumentsRequest", spec$4(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.hash);
  };
}

function constructor$9(hash) {
  return {
          hash: hash
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.ListPublicSignDocumentsRequest", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListPublicSignDocumentsRequest, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$5(param) {
  return ".buhta.edo.sign.v1alpha1.ListPublicSignDocumentsResponse";
}

function make$5(documentsOpt, param) {
  const documents = documentsOpt !== undefined ? documentsOpt : /* [] */0;
  return {
          documents: documents
        };
}

const $$let$1 = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSignIntent;

const merge_documents = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "documents",
            "documents"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$5(t1, t2) {
  return {
          documents: Curry._2(merge_documents, t1.documents, t2.documents)
        };
}

function spec$5(param) {
  const $$let = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSignIntent;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "documents",
                    "documents"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.documents);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(documents) {
  return {
          documents: documents
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.ListPublicSignDocumentsResponse", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.documents);
  };
}

function constructor$11(documents) {
  return {
          documents: documents
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.ListPublicSignDocumentsResponse", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListPublicSignDocumentsResponse, {
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$5,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

function name$6(param) {
  return ".buhta.edo.sign.v1alpha1.ProcessPublicSignDocumentsRequest";
}

function make$6(hashOpt, documentsOpt, param) {
  const hash = hashOpt !== undefined ? hashOpt : "";
  const documents = documentsOpt !== undefined ? documentsOpt : /* [] */0;
  return {
          hash: hash,
          documents: documents
        };
}

const merge_hash$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "hash",
            "hash"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$2 = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSign;

const merge_documents$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "documents",
            "documents"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$6(t1, t2) {
  return {
          hash: Curry._2(merge_hash$4, t1.hash, t2.hash),
          documents: Curry._2(merge_documents$1, t1.documents, t2.documents)
        };
}

function spec$6(param) {
  const $$let = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSign;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "hash",
                    "hash"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                      [
                        2,
                        "documents",
                        "documents"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let.name,
                            make: $$let.make,
                            from_proto: $$let.from_proto,
                            from_proto_exn: $$let.from_proto_exn,
                            to_proto: $$let.to_proto,
                            to_proto$p: $$let.to_proto$p,
                            merge: $$let.merge,
                            to_json: $$let.to_json,
                            from_json_exn: $$let.from_json_exn,
                            from_json: $$let.from_json
                          }),
                      Ocaml_protoc_plugin__Spec.not_packed
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
    });

function to_proto$p$6(writer, param) {
  Curry._3(serialize$6, writer, param.hash, param.documents);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(hash, documents) {
  return {
          hash: hash,
          documents: documents
        };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
    });

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$6, writer);
            });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.ProcessPublicSignDocumentsRequest", spec$6(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.hash, param.documents);
  };
}

function constructor$13(hash, documents) {
  return {
          hash: hash,
          documents: documents
        };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.ProcessPublicSignDocumentsRequest", spec$6(undefined), constructor$13);
    });

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$6, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ProcessPublicSignDocumentsRequest, {
      make: make$6,
      to_proto: to_proto$6,
      from_proto: from_proto$6,
      to_json: to_json$6,
      from_json: from_json$6,
      name: name$6,
      merge: merge$6,
      to_proto$p: to_proto$p$6,
      from_proto_exn: from_proto_exn$6,
      from_json_exn: from_json_exn$6
    });

function name$7(param) {
  return ".buhta.edo.sign.v1alpha1.ProcessPublicSignDocumentsResponse";
}

function make$7(documentsOpt, param) {
  const documents = documentsOpt !== undefined ? documentsOpt : /* [] */0;
  return {
          documents: documents
        };
}

const $$let$3 = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSignResult;

const merge_documents$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "documents",
            "documents"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$7(t1, t2) {
  return {
          documents: Curry._2(merge_documents$2, t1.documents, t2.documents)
        };
}

function spec$7(param) {
  const $$let = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSignResult;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "documents",
                    "documents"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
    });

function to_proto$p$7(writer, param) {
  Curry._2(serialize$7, writer, param.documents);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(documents) {
  return {
          documents: documents
        };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
    });

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$7, writer);
            });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.ProcessPublicSignDocumentsResponse", spec$7(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.documents);
  };
}

function constructor$15(documents) {
  return {
          documents: documents
        };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.ProcessPublicSignDocumentsResponse", spec$7(undefined), constructor$15);
    });

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$7, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ProcessPublicSignDocumentsResponse, {
      make: make$7,
      to_proto: to_proto$7,
      from_proto: from_proto$7,
      to_json: to_json$7,
      from_json: from_json$7,
      name: name$7,
      merge: merge$7,
      to_proto$p: to_proto$p$7,
      from_proto_exn: from_proto_exn$7,
      from_json_exn: from_json_exn$7
    });

const getPublicSignDocument_0 = {
  name: GetPublicSignDocumentRequest.name,
  make: GetPublicSignDocumentRequest.make,
  from_proto: GetPublicSignDocumentRequest.from_proto,
  from_proto_exn: GetPublicSignDocumentRequest.from_proto_exn,
  to_proto: GetPublicSignDocumentRequest.to_proto,
  to_proto$p: GetPublicSignDocumentRequest.to_proto$p,
  merge: GetPublicSignDocumentRequest.merge,
  to_json: GetPublicSignDocumentRequest.to_json,
  from_json_exn: GetPublicSignDocumentRequest.from_json_exn,
  from_json: GetPublicSignDocumentRequest.from_json
};

const getPublicSignDocument_1 = {
  name: GetPublicSignDocumentResponse.name,
  make: GetPublicSignDocumentResponse.make,
  from_proto: GetPublicSignDocumentResponse.from_proto,
  from_proto_exn: GetPublicSignDocumentResponse.from_proto_exn,
  to_proto: GetPublicSignDocumentResponse.to_proto,
  to_proto$p: GetPublicSignDocumentResponse.to_proto$p,
  merge: GetPublicSignDocumentResponse.merge,
  to_json: GetPublicSignDocumentResponse.to_json,
  from_json_exn: GetPublicSignDocumentResponse.from_json_exn,
  from_json: GetPublicSignDocumentResponse.from_json
};

const getPublicSignDocument = [
  getPublicSignDocument_0,
  getPublicSignDocument_1
];

const $$let$4 = Google_api__Google_api_httpbody.Google.Api.HttpBody;

const getPublicSignDocumentPreview_0 = {
  name: GetPublicSignDocumentPreviewRequest.name,
  make: GetPublicSignDocumentPreviewRequest.make,
  from_proto: GetPublicSignDocumentPreviewRequest.from_proto,
  from_proto_exn: GetPublicSignDocumentPreviewRequest.from_proto_exn,
  to_proto: GetPublicSignDocumentPreviewRequest.to_proto,
  to_proto$p: GetPublicSignDocumentPreviewRequest.to_proto$p,
  merge: GetPublicSignDocumentPreviewRequest.merge,
  to_json: GetPublicSignDocumentPreviewRequest.to_json,
  from_json_exn: GetPublicSignDocumentPreviewRequest.from_json_exn,
  from_json: GetPublicSignDocumentPreviewRequest.from_json
};

const getPublicSignDocumentPreview_1 = {
  name: $$let$4.name,
  make: $$let$4.make,
  from_proto: $$let$4.from_proto,
  from_proto_exn: $$let$4.from_proto_exn,
  to_proto: $$let$4.to_proto,
  to_proto$p: $$let$4.to_proto$p,
  merge: $$let$4.merge,
  to_json: $$let$4.to_json,
  from_json_exn: $$let$4.from_json_exn,
  from_json: $$let$4.from_json
};

const getPublicSignDocumentPreview = [
  getPublicSignDocumentPreview_0,
  getPublicSignDocumentPreview_1
];

const $$let$5 = Google_api__Google_api_httpbody.Google.Api.HttpBody;

const getPublicSignDocumentContent_0 = {
  name: GetPublicSignDocumentContentRequest.name,
  make: GetPublicSignDocumentContentRequest.make,
  from_proto: GetPublicSignDocumentContentRequest.from_proto,
  from_proto_exn: GetPublicSignDocumentContentRequest.from_proto_exn,
  to_proto: GetPublicSignDocumentContentRequest.to_proto,
  to_proto$p: GetPublicSignDocumentContentRequest.to_proto$p,
  merge: GetPublicSignDocumentContentRequest.merge,
  to_json: GetPublicSignDocumentContentRequest.to_json,
  from_json_exn: GetPublicSignDocumentContentRequest.from_json_exn,
  from_json: GetPublicSignDocumentContentRequest.from_json
};

const getPublicSignDocumentContent_1 = {
  name: $$let$5.name,
  make: $$let$5.make,
  from_proto: $$let$5.from_proto,
  from_proto_exn: $$let$5.from_proto_exn,
  to_proto: $$let$5.to_proto,
  to_proto$p: $$let$5.to_proto$p,
  merge: $$let$5.merge,
  to_json: $$let$5.to_json,
  from_json_exn: $$let$5.from_json_exn,
  from_json: $$let$5.from_json
};

const getPublicSignDocumentContent = [
  getPublicSignDocumentContent_0,
  getPublicSignDocumentContent_1
];

const listPublicSignDocuments_0 = {
  name: ListPublicSignDocumentsRequest.name,
  make: ListPublicSignDocumentsRequest.make,
  from_proto: ListPublicSignDocumentsRequest.from_proto,
  from_proto_exn: ListPublicSignDocumentsRequest.from_proto_exn,
  to_proto: ListPublicSignDocumentsRequest.to_proto,
  to_proto$p: ListPublicSignDocumentsRequest.to_proto$p,
  merge: ListPublicSignDocumentsRequest.merge,
  to_json: ListPublicSignDocumentsRequest.to_json,
  from_json_exn: ListPublicSignDocumentsRequest.from_json_exn,
  from_json: ListPublicSignDocumentsRequest.from_json
};

const listPublicSignDocuments_1 = {
  name: ListPublicSignDocumentsResponse.name,
  make: ListPublicSignDocumentsResponse.make,
  from_proto: ListPublicSignDocumentsResponse.from_proto,
  from_proto_exn: ListPublicSignDocumentsResponse.from_proto_exn,
  to_proto: ListPublicSignDocumentsResponse.to_proto,
  to_proto$p: ListPublicSignDocumentsResponse.to_proto$p,
  merge: ListPublicSignDocumentsResponse.merge,
  to_json: ListPublicSignDocumentsResponse.to_json,
  from_json_exn: ListPublicSignDocumentsResponse.from_json_exn,
  from_json: ListPublicSignDocumentsResponse.from_json
};

const listPublicSignDocuments = [
  listPublicSignDocuments_0,
  listPublicSignDocuments_1
];

const processPublicSignDocuments_0 = {
  name: ProcessPublicSignDocumentsRequest.name,
  make: ProcessPublicSignDocumentsRequest.make,
  from_proto: ProcessPublicSignDocumentsRequest.from_proto,
  from_proto_exn: ProcessPublicSignDocumentsRequest.from_proto_exn,
  to_proto: ProcessPublicSignDocumentsRequest.to_proto,
  to_proto$p: ProcessPublicSignDocumentsRequest.to_proto$p,
  merge: ProcessPublicSignDocumentsRequest.merge,
  to_json: ProcessPublicSignDocumentsRequest.to_json,
  from_json_exn: ProcessPublicSignDocumentsRequest.from_json_exn,
  from_json: ProcessPublicSignDocumentsRequest.from_json
};

const processPublicSignDocuments_1 = {
  name: ProcessPublicSignDocumentsResponse.name,
  make: ProcessPublicSignDocumentsResponse.make,
  from_proto: ProcessPublicSignDocumentsResponse.from_proto,
  from_proto_exn: ProcessPublicSignDocumentsResponse.from_proto_exn,
  to_proto: ProcessPublicSignDocumentsResponse.to_proto,
  to_proto$p: ProcessPublicSignDocumentsResponse.to_proto$p,
  merge: ProcessPublicSignDocumentsResponse.merge,
  to_json: ProcessPublicSignDocumentsResponse.to_json,
  from_json_exn: ProcessPublicSignDocumentsResponse.from_json_exn,
  from_json: ProcessPublicSignDocumentsResponse.from_json
};

const processPublicSignDocuments = [
  processPublicSignDocuments_0,
  processPublicSignDocuments_1
];

const $$let$6 = Google_api__Google_api_httpbody.Google.Api.HttpBody;

const $$let$7 = Google_api__Google_api_httpbody.Google.Api.HttpBody;

const V1alpha1_PublicSignService = {
  GetPublicSignDocument: {
    name: "/buhta.edo.sign.v1alpha1.PublicSignService/GetPublicSignDocument",
    package_name: "buhta.edo.sign.v1alpha1",
    service_name: "PublicSignService",
    method_name: "GetPublicSignDocument",
    $$Request: {
      name: GetPublicSignDocumentRequest.name,
      make: GetPublicSignDocumentRequest.make,
      from_proto: GetPublicSignDocumentRequest.from_proto,
      from_proto_exn: GetPublicSignDocumentRequest.from_proto_exn,
      to_proto: GetPublicSignDocumentRequest.to_proto,
      to_proto$p: GetPublicSignDocumentRequest.to_proto$p,
      merge: GetPublicSignDocumentRequest.merge,
      to_json: GetPublicSignDocumentRequest.to_json,
      from_json_exn: GetPublicSignDocumentRequest.from_json_exn,
      from_json: GetPublicSignDocumentRequest.from_json
    },
    $$Response: {
      name: GetPublicSignDocumentResponse.name,
      make: GetPublicSignDocumentResponse.make,
      from_proto: GetPublicSignDocumentResponse.from_proto,
      from_proto_exn: GetPublicSignDocumentResponse.from_proto_exn,
      to_proto: GetPublicSignDocumentResponse.to_proto,
      to_proto$p: GetPublicSignDocumentResponse.to_proto$p,
      merge: GetPublicSignDocumentResponse.merge,
      to_json: GetPublicSignDocumentResponse.to_json,
      from_json_exn: GetPublicSignDocumentResponse.from_json_exn,
      from_json: GetPublicSignDocumentResponse.from_json
    }
  },
  getPublicSignDocument: getPublicSignDocument,
  GetPublicSignDocumentPreview: {
    name: "/buhta.edo.sign.v1alpha1.PublicSignService/GetPublicSignDocumentPreview",
    package_name: "buhta.edo.sign.v1alpha1",
    service_name: "PublicSignService",
    method_name: "GetPublicSignDocumentPreview",
    $$Request: {
      name: GetPublicSignDocumentPreviewRequest.name,
      make: GetPublicSignDocumentPreviewRequest.make,
      from_proto: GetPublicSignDocumentPreviewRequest.from_proto,
      from_proto_exn: GetPublicSignDocumentPreviewRequest.from_proto_exn,
      to_proto: GetPublicSignDocumentPreviewRequest.to_proto,
      to_proto$p: GetPublicSignDocumentPreviewRequest.to_proto$p,
      merge: GetPublicSignDocumentPreviewRequest.merge,
      to_json: GetPublicSignDocumentPreviewRequest.to_json,
      from_json_exn: GetPublicSignDocumentPreviewRequest.from_json_exn,
      from_json: GetPublicSignDocumentPreviewRequest.from_json
    },
    $$Response: {
      name: $$let$6.name,
      make: $$let$6.make,
      from_proto: $$let$6.from_proto,
      from_proto_exn: $$let$6.from_proto_exn,
      to_proto: $$let$6.to_proto,
      to_proto$p: $$let$6.to_proto$p,
      merge: $$let$6.merge,
      to_json: $$let$6.to_json,
      from_json_exn: $$let$6.from_json_exn,
      from_json: $$let$6.from_json
    }
  },
  getPublicSignDocumentPreview: getPublicSignDocumentPreview,
  GetPublicSignDocumentContent: {
    name: "/buhta.edo.sign.v1alpha1.PublicSignService/GetPublicSignDocumentContent",
    package_name: "buhta.edo.sign.v1alpha1",
    service_name: "PublicSignService",
    method_name: "GetPublicSignDocumentContent",
    $$Request: {
      name: GetPublicSignDocumentContentRequest.name,
      make: GetPublicSignDocumentContentRequest.make,
      from_proto: GetPublicSignDocumentContentRequest.from_proto,
      from_proto_exn: GetPublicSignDocumentContentRequest.from_proto_exn,
      to_proto: GetPublicSignDocumentContentRequest.to_proto,
      to_proto$p: GetPublicSignDocumentContentRequest.to_proto$p,
      merge: GetPublicSignDocumentContentRequest.merge,
      to_json: GetPublicSignDocumentContentRequest.to_json,
      from_json_exn: GetPublicSignDocumentContentRequest.from_json_exn,
      from_json: GetPublicSignDocumentContentRequest.from_json
    },
    $$Response: {
      name: $$let$7.name,
      make: $$let$7.make,
      from_proto: $$let$7.from_proto,
      from_proto_exn: $$let$7.from_proto_exn,
      to_proto: $$let$7.to_proto,
      to_proto$p: $$let$7.to_proto$p,
      merge: $$let$7.merge,
      to_json: $$let$7.to_json,
      from_json_exn: $$let$7.from_json_exn,
      from_json: $$let$7.from_json
    }
  },
  getPublicSignDocumentContent: getPublicSignDocumentContent,
  ListPublicSignDocuments: {
    name: "/buhta.edo.sign.v1alpha1.PublicSignService/ListPublicSignDocuments",
    package_name: "buhta.edo.sign.v1alpha1",
    service_name: "PublicSignService",
    method_name: "ListPublicSignDocuments",
    $$Request: {
      name: ListPublicSignDocumentsRequest.name,
      make: ListPublicSignDocumentsRequest.make,
      from_proto: ListPublicSignDocumentsRequest.from_proto,
      from_proto_exn: ListPublicSignDocumentsRequest.from_proto_exn,
      to_proto: ListPublicSignDocumentsRequest.to_proto,
      to_proto$p: ListPublicSignDocumentsRequest.to_proto$p,
      merge: ListPublicSignDocumentsRequest.merge,
      to_json: ListPublicSignDocumentsRequest.to_json,
      from_json_exn: ListPublicSignDocumentsRequest.from_json_exn,
      from_json: ListPublicSignDocumentsRequest.from_json
    },
    $$Response: {
      name: ListPublicSignDocumentsResponse.name,
      make: ListPublicSignDocumentsResponse.make,
      from_proto: ListPublicSignDocumentsResponse.from_proto,
      from_proto_exn: ListPublicSignDocumentsResponse.from_proto_exn,
      to_proto: ListPublicSignDocumentsResponse.to_proto,
      to_proto$p: ListPublicSignDocumentsResponse.to_proto$p,
      merge: ListPublicSignDocumentsResponse.merge,
      to_json: ListPublicSignDocumentsResponse.to_json,
      from_json_exn: ListPublicSignDocumentsResponse.from_json_exn,
      from_json: ListPublicSignDocumentsResponse.from_json
    }
  },
  listPublicSignDocuments: listPublicSignDocuments,
  ProcessPublicSignDocuments: {
    name: "/buhta.edo.sign.v1alpha1.PublicSignService/ProcessPublicSignDocuments",
    package_name: "buhta.edo.sign.v1alpha1",
    service_name: "PublicSignService",
    method_name: "ProcessPublicSignDocuments",
    $$Request: {
      name: ProcessPublicSignDocumentsRequest.name,
      make: ProcessPublicSignDocumentsRequest.make,
      from_proto: ProcessPublicSignDocumentsRequest.from_proto,
      from_proto_exn: ProcessPublicSignDocumentsRequest.from_proto_exn,
      to_proto: ProcessPublicSignDocumentsRequest.to_proto,
      to_proto$p: ProcessPublicSignDocumentsRequest.to_proto$p,
      merge: ProcessPublicSignDocumentsRequest.merge,
      to_json: ProcessPublicSignDocumentsRequest.to_json,
      from_json_exn: ProcessPublicSignDocumentsRequest.from_json_exn,
      from_json: ProcessPublicSignDocumentsRequest.from_json
    },
    $$Response: {
      name: ProcessPublicSignDocumentsResponse.name,
      make: ProcessPublicSignDocumentsResponse.make,
      from_proto: ProcessPublicSignDocumentsResponse.from_proto,
      from_proto_exn: ProcessPublicSignDocumentsResponse.from_proto_exn,
      to_proto: ProcessPublicSignDocumentsResponse.to_proto,
      to_proto$p: ProcessPublicSignDocumentsResponse.to_proto$p,
      merge: ProcessPublicSignDocumentsResponse.merge,
      to_json: ProcessPublicSignDocumentsResponse.to_json,
      from_json_exn: ProcessPublicSignDocumentsResponse.from_json_exn,
      from_json: ProcessPublicSignDocumentsResponse.from_json
    }
  },
  processPublicSignDocuments: processPublicSignDocuments
};

const V1alpha1 = {
  GetPublicSignDocumentRequest: GetPublicSignDocumentRequest,
  GetPublicSignDocumentResponse: GetPublicSignDocumentResponse,
  GetPublicSignDocumentContentRequest: GetPublicSignDocumentContentRequest,
  GetPublicSignDocumentPreviewRequest: GetPublicSignDocumentPreviewRequest,
  ListPublicSignDocumentsRequest: ListPublicSignDocumentsRequest,
  ListPublicSignDocumentsResponse: ListPublicSignDocumentsResponse,
  ProcessPublicSignDocumentsRequest: ProcessPublicSignDocumentsRequest,
  ProcessPublicSignDocumentsResponse: ProcessPublicSignDocumentsResponse,
  PublicSignService: V1alpha1_PublicSignService
};

const Sign = {
  V1alpha1: V1alpha1
};

const Edo = {
  Sign: Sign
};

const Buhta = {
  Edo: Edo
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetPublicSignDocumentRequest Not a pure module */
